module.exports = __webpack_public_path__ + "img/logo.67bb86f.png";